var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroupe1677(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 97,
    height: 106,
    viewBox: "0 0 97 106",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1677",
    "data-name": "Groupe 1677",
    transform: "translate(-8588 -1734)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1284",
    "data-name": "Rectangle 1284",
    d: "M0,0H97a0,0,0,0,1,0,0V57.5A48.5,48.5,0,0,1,48.5,106h0A48.5,48.5,0,0,1,0,57.5V0A0,0,0,0,1,0,0Z",
    transform: "translate(8588 1734)",
    fill: "#f3f8ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "vuesax_linear_filter-add",
    "data-name": "vuesax/linear/filter-add",
    transform: "translate(8191.852 1070.351)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "filter-add",
    transform: "translate(428 700)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.18,6.59a6.5,6.5,0,0,1-.957,3.4,6.567,6.567,0,0,1-11.266,0A6.465,6.465,0,0,1,0,6.59a6.59,6.59,0,1,1,13.18,0Z",
    transform: "translate(16.829 13.874)",
    fill: "none",
    stroke: "#1b7afa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(20.964 18.036)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M4.925,0H0",
    transform: "translate(0 2.4)",
    fill: "none",
    stroke: "#1b7afa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0V4.925",
    transform: "translate(2.456)",
    fill: "none",
    stroke: "#1b7afa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M0,0H33.3V33.3H0Z",
    transform: "translate(33.298 33.298) rotate(180)",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    "data-name": "Group",
    transform: "translate(4.592 2.775)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M24.113,2.8v3.08a5.307,5.307,0,0,1-1.4,3.233l-2.442,2.15a6.134,6.134,0,0,0-1.443-.166,6.6,6.6,0,0,0-6.59,6.59,6.5,6.5,0,0,0,.957,3.4,6.217,6.217,0,0,0,2.081,2.123v.472a3.094,3.094,0,0,1-1.263,2.386l-1.956,1.263a2.855,2.855,0,0,1-4.343-2.386V17.523A5.425,5.425,0,0,0,6.59,14.582L1.263,8.977A4.726,4.726,0,0,1,0,6.174V2.941A2.845,2.845,0,0,1,2.8,0H21.311A2.813,2.813,0,0,1,24.113,2.8Z",
    fill: "none",
    stroke: "#1b7afa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupe1677);
export default __webpack_public_path__ + "static/media/Groupe-1677.11a72f62fb93d884054e72b852529aa5.svg";
export { ForwardRef as ReactComponent };